import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

export type FractionalMode = 'percent' | 'numerator' | 'convert';
export type FractionalLabelMode = 'label' | 'value' | 'both';
export type FractionalValue = {
	mode: FractionalMode;
	labelMode: FractionalLabelMode;
	denom: '' | string;
}
@Component({
	selector: 'app-fractional-values-sel',
	templateUrl: './fractional-values-sel.component.html',
	styleUrls: ['./fractional-values-sel.component.scss']
})
export class FractionalValuesSelComponent implements OnInit {

	public static defaultValue: FractionalValue = {
		mode: 'percent',
		labelMode: 'label',
		denom: ''
	}

	public _val: FractionalValue = {
		mode: 'percent',
		labelMode: 'label',
		denom: ''
	}
	@Input('value')
	public set value(val: FractionalValue) {
		if (!(!!val.denom)) {
			val.denom = '';
		}
		let hadChanges = true;
		if ((val.denom === this._val.denom) && (val.labelMode === this._val.labelMode) && (val.mode === this._val.mode)) {
			hadChanges = false;
		}
		this._val = {
			denom: val.denom,
			labelMode: val.labelMode,
			mode: val.mode
		}
		if (hadChanges === true) {
			this.valueChange.emit(this._val);
		}

	}
	public get value() {
		return this._val;
	}
	@Output()
	public valueChange = new EventEmitter<FractionalValue>();

	public UpdateMode(newMode: FractionalMode) {
		this._val.mode = newMode;
		this.valueChange.emit(this._val);
	}

	public UpdateDenom(denom: '' | string = '') {
		this._val.denom = denom;
		this.valueChange.emit(this._val);
	}

	public UpdateLabelMode(labelMode: FractionalLabelMode) {
		this._val.labelMode = labelMode;
		this.valueChange.emit(this._val);
	}
	constructor() {

	}

	ngOnInit(): void {
	}

}
